module.exports = __webpack_public_path__ + "static/media/ic_info_black.73a30db9.png";